import i18next from 'i18next'
import * as yup from 'yup'

import { DATAGRID_HEADER_HEIGHT, DATAGRID_HEADER_MAX_HEIGHT } from '@constants'

export const entityConfigurationSchema = yup.object().shape({
  headerHeight: yup
    .string()
    .test(
      'max',
      i18next.t('parameters.errors.headerHeightMinAndMax'),
      val => Number(val) >= DATAGRID_HEADER_HEIGHT && Number(val) <= DATAGRID_HEADER_MAX_HEIGHT
    )
    .notRequired(),
  headerGroupHeight: yup
    .string()
    .test(
      'max',
      i18next.t('parameters.errors.headerHeightMinAndMax'),
      val => Number(val) >= DATAGRID_HEADER_HEIGHT && Number(val) <= DATAGRID_HEADER_MAX_HEIGHT
    )
    .notRequired(),
})
